import React, { useState } from 'react'
import { Link } from 'gatsby'
import styled from 'styled-components'

export const Logo = styled.span`
  mask: url(/assets/img/NodeDotDevLogo_DarkBG.svg) no-repeat;
  display: block;
  height: 50px;
  margin-top: 12px;
  background-color: #fff;
`

const Header = () => {
  const [isShow, setShow] = useState(false)

  return (
    <header>
      <div id='fixed-header-light' className='header-output fixed-header'>
        <div className='header-output'>
          <div className='container header-in'>
            <div className='position-relative'>
              <div className='row'>
                <div className='col-lg-3 col-md-12'>
                  <Link to='/' aria-label='Header Logo Node.dev'>
                    <Logo className='logo-header' />
                  </Link>
                  <button aria-label='Menu Mobile Toggle' className='mobile-toggle padding-15px background-second-color border-radius-3' onClick={() => setShow(!isShow)}><i className='fa fa-bars' /></button>
                </div>
                <div className={`col-lg-9 col-md-12 position-inherit ${isShow ? 'show-menu' : 'hide-menu'}`}>
                  <ul className='nav-menu float-xl-right text-lg-center link-padding-tb-25px dropdown-light'>
                    <li className='has-dropdown'><Link to='/videos'>Videos</Link></li>
                    <li className='has-dropdown'><Link to='/blogs'>Blogs</Link></li>
                    <li className='has-dropdown'><Link to='/node-binary'>Node.JS Binary Distributions</Link></li>
                    <li className='has-dropdown'><Link to='/community'>Community</Link></li>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </header>
  )
}

export default Header
